import React, { useState, useEffect } from 'react';

import { ListItem } from '../../../../Components/List';
import SearchBar from '../../../../Components/SearchBar';
import SearchProducts from '../SearchProducts';
import ModalHeader from '../../../../Components/ModalHeader';
import ModalSection from '../../../../Components/ModalSection';
import ModalBody from '../../../../Components/ModalBody';
import ModalFooter from '../../../../Components/ModalFooter';
import { Article } from '../../../../Components/Article/Article';
import Btn from '../../../../Components/Btn';
import IconBtn from '../../../../Components/IconBtn';
import { EmptyState } from '../../../../Components/EmptyState/EmptyState';
import {ProductThumb} from '../../../../Components/Product/ProductThumb';
import { useRankingContext } from '../../Ranking/context/RankingContextProvider';
import { replaceId } from '../../Ranking/utils';

export default function ReplacementList({
	addReplaceManualy,
	valueOfSelection = {
		toReplaceId: '',
		replaceId: ''
	},
	fromProduct,
	onAdd,
	setModalHeight
}) {

	const {
		rankingObject,
		searchProductFeed,
		searchProductsByTerm,
		localArrayOfProductIdSwap,
		setLocalArrayOfProductIdSwap,
		setNeedToLoadSwap,
		setModalManualIsOpen,
		setIsSwapList,
	} = useRankingContext();

	const selectedTenant = rankingObject.tenant;
	const [step, setStep] = useState(1);
	const [valueToModify, setValueToModify] = useState(valueOfSelection);
	const [searchTerm, setSearchTerm] = useState('');
	const [searchTermForInput, setSearchTermForInput] = useState('');
	const [firstProduct, setFirstProduct] = useState();
	const [secondProduct, setSecondProduct] = useState();
	const [deleteList, setDeleteList] = useState(true);

	useEffect(() => {
		const searchTimeout = setTimeout(() => {
			setSearchTerm(searchTermForInput);
			setDeleteList(!!searchTermForInput);
		}, 500);

		return () => {
			clearTimeout(searchTimeout);
		};
	}, [searchTermForInput]);

	function returnTo(point) {
		if (point === 1) {
			setFirstProduct();
			setSecondProduct();
		}
		if (point === 2) {
			setSecondProduct();
		}
		setStep(point);
		setSearchTerm('');
		setSearchTermForInput('');
		setDeleteList(true);
	}

	function addProduct(p){
		if(step === 1){
			setFirstProduct(p);
			setStep(2);
			setSearchTerm('');
			setSearchTermForInput('');
			setValueToModify({
				...valueToModify,
				toReplaceId: p.id
			});
			setDeleteList(true);
		}else{
			setSecondProduct(p);
			setStep(3);
			setSearchTerm('');
			setSearchTermForInput('');
			setValueToModify({
				...valueToModify,
				replaceId: p.id
			});
			setDeleteList(true);
		}
	}

	useEffect(()=>{
		if(valueToModify){
			addReplaceManualy(valueToModify);
		}
	},[valueToModify]);

	useEffect(()=>{
		setModalHeight(step === 3 ? null : 640);
	},[step]);

	useEffect(()=>{
		if(fromProduct){

			if (!selectedTenant === null) {
				searchProductFeed.postSearchEmptyTenant(
					{
						ids: [valueToModify.toReplaceId],
						requestedFields: ['NameAndThumbnail', 'Categories',],
					},
					(data) => {
						if (data && data.products) {
							const updatedProducts =  [valueToModify.toReplaceId].map(id => {
								const product = data.products.find(p => p.id === id);
								if (product) {
									return { id: product.id, name: product.name, urlThumbnail: product.urlThumbnail };
								}
								return null;
							}).filter(product => product !== null);
							setFirstProduct(updatedProducts[0]);
							setStep(2);
						} else {
							console.error('No products found in the response');
						}
					},
					(error) => {
						console.log('=>(SearchProduct.tsx:77) error', error);
					}
				);
			} else{
				searchProductFeed.postSearchWithTenant(
					{
						'ids': [valueToModify.toReplaceId],
						'requestedFields': ['NameAndThumbnail', 'Categories',],
					},
					selectedTenant,
					(data) => {
						if (data && data.products) {
							const updatedProducts =  [valueToModify.toReplaceId].map(id => {
								const product = data.products.find(p => p.id === id);
								if (product) {
									return { id: product.id, name: product.name, urlThumbnail: product.urlThumbnail };
								}
								return null;
							}).filter(product => product !== null);
							setFirstProduct(updatedProducts[0]);
							setStep(2);
						} else {
							console.error('No products found in the response');
						}
					},
					(error) => {
						console.log('=>(SearchProduct.tsx:77) error', error);
					}
				);
			}
			
		}
	},[fromProduct]);

	function addFunction(){
		if (fromProduct) {
			if (typeof onAdd === 'function') onAdd();
			return;
		}
		const newReplaceTranformation = {
			collationId: replaceId,
			idOld: [valueToModify.replaceId],
			idReplace: [valueToModify.toReplaceId],
			params: [{
				name: 'First Product Id',
				value: {
					stringValues: [valueToModify.replaceId],
				}
			},
			{
				name: 'Second Product Id',
				value: {
					stringValues: [valueToModify.toReplaceId],
				}
			},
			]
		};
		const newTransformationObj = [...localArrayOfProductIdSwap,
			newReplaceTranformation
		];
		setLocalArrayOfProductIdSwap(newTransformationObj);
		setNeedToLoadSwap(true);
		setModalManualIsOpen(false);
		setIsSwapList(false);
	}

	return (
		<>
			{step === 1 &&
				<ModalHeader
					title={'Swap products - 1/2'}
					hasBorder={false}
					hasBottomPadding={false}
				/>
			}
			{step === 2 &&
				<ModalHeader
					title={'Swap products - 2/2'}
					hasBorder={false}
					hasBottomPadding={false}
					backButton={
						<IconBtn
							icon='fas fa-arrow-left'
							isActive={true}
							onClick={() => returnTo(1)}
						/>
					}
				/>
			}
			{step === 3 &&
				<ModalHeader
					title={'Swap these 2 products'}
					hasBorder={false}
					hasBottomPadding={false}
					backButton={
						<IconBtn
							icon='fas fa-arrow-left'
							isActive={true}
							onClick={() => returnTo(2)}
						/>
					}
				/>
			}
			<ModalSection>
				{firstProduct &&
					<div className='mb_10'>
						<Article color='grey' innerSize='s' hasMargin={false}>
							<ListItem
								key={firstProduct.id}
								text={firstProduct.name}
								textHasEllipsis={true}
								textIsBold={false}
								description={firstProduct.id}
								picto={
									<ProductThumb
										url={firstProduct.urlThumbnail}
										alt={firstProduct.name}
										hasMargin={false}
										width={40}
										backgroundColor={'white'}
									/>
								}
							/>
						</Article>
					</div>
				}
				{step !== 3 &&
					<SearchBar
						value={searchTermForInput}
						onChange={(v) => setSearchTermForInput(v)}
						placeholder={
							step === 1 ?
								'Select the first product'
								:
								'Select the second product'
						}
						fullWidth={true}
						size='l'
					/>
				}
				{secondProduct &&
					<Article color='grey' innerSize='s' hasMargin={false}>
						<ListItem
							key={secondProduct.id}
							text={secondProduct.name}
							textHasEllipsis={true}
							textIsBold={false}
							description={secondProduct.id}
							picto={
								<ProductThumb
									url={secondProduct.urlThumbnail}
									alt={secondProduct.name}
									hasMargin={false}
									width={40}
									backgroundColor={'white'}
								/>
							}
						/>
					</Article>
				}
			</ModalSection>
			{step !== 3 &&
				<ModalBody hasTopPadding={false} position='relative'>
					{step === 1 && !searchTerm &&
						<EmptyState
							text="Use the search field to select the first product to swap"
							textSize='l'
							width='s'
							verticalAlign={true}
						/>
					}
					{step === 2 && !searchTerm &&
						<EmptyState
							text="Use the search field to select the second product to swap"
							textSize='l'
							width='s'
							verticalAlign={true}
						/>
					}
					<SearchProducts
						needTenantForSearch={selectedTenant !== null}
						tenanSelected={selectedTenant}
						searchTerm={searchTerm}
						onAddProduct={addProduct}
						arrayOfIdsToExcludes={[]}
						searchProductsByTerm={(s, e) => searchProductsByTerm(searchTerm, s, e)}
						allProduct={true}
						deleteList={deleteList}
						size={'s'}
						showTitle={false}
					/>
				</ModalBody>
			}
			{step === 3 &&
				<ModalFooter
					primaryAction={
						<Btn
							onClick={() => addFunction()}
							message="Confirm"
							color="primary"
						/>
					}
				/>
			}
		</>
	);
}
